import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatBytes(bytes: number, decimals = 2) {
  const value = Number(bytes)
  if (!Number.isFinite(value) || value <= 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB']
  const rawIndex = Math.floor(Math.log(value) / Math.log(k))
  const i = Math.min(Math.max(rawIndex, 0), sizes.length - 1)

  return `${parseFloat((value / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}
